import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { CompanySlider } from '../../components/company-slider';
import { CookiePolicyModal, CookieSettingsModal } from '../../components/cookie-policy';
import FinalSection from '../../components/final-section/final-section';
import Advantages from '../../components/marketing-advantages/advantages';
import { Hero } from '../../components/marketing-hero';
import { Footer } from '../../components/site-footer';
import { Header } from '../../components/site-header';
import ToolsTabs from '../../components/tools-tabs/tools-tabs';
import { useModalState } from '../../hooks/use-modal-state.hook';
import { cookieSettingsStore } from '../../storage/cookie-settings';

const isReactSnapPrerender =
  typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

export const Home = () => {
  const [isHovered, setIsHovered] = useState(false);
  const cookieSettings = cookieSettingsStore.get();
  const [isOpenCookieModal, setIsOpenCookieModal] = useState<boolean>(
    !isReactSnapPrerender && !cookieSettings,
  );
  const {
    isOpen: isOpenCookieSettingsModal,
    handleOpenModal: handleOpenCookieSettingsModal,
    handleCloseModal: handleCloseCookieSettingsModal,
  } = useModalState();

  return (
    <>
      <CookiePolicyModal
        handleCloseModal={() => setIsOpenCookieModal(false)}
        handleOpenSettingsModal={handleOpenCookieSettingsModal}
        isOpenModal={isOpenCookieModal}
      />
      <CookieSettingsModal
        handleCloseModal={handleCloseCookieSettingsModal}
        handleOpenCookieModal={() => setIsOpenCookieModal(true)}
        isOpenModal={isOpenCookieSettingsModal}
      />

      <div className="font-inter relative text-center text-sm font-normal text-gray-700">
        <div
          className={twMerge(
            isHovered &&
              `z-2 absolute inset-0 bg-[linear-gradient(180deg,rgba(37,101,200,0.06)0%,rgba(2,8,17,0.36)100%)] backdrop-blur-[8px] transition-all duration-300`,
          )}
          style={isHovered ? { pointerEvents: 'none' } : {}}
        />

        <main className="flex flex-col items-center transition-all duration-300">
          <div className="relative w-full max-w-full overflow-hidden bg-[#E6F0FF]">
            {/* <div className="absolute -left-[271px] -top-[248px] h-[496px] w-[542px] rounded-full bg-[#2565C8] opacity-40 blur-[368px]" />
            <div className="absolute right-[432px] top-[172px] h-[87px] w-[174px] rounded-full bg-[#2565C8] opacity-100 blur-[124px]" />
            <div className="absolute -bottom-[205px] -right-[440px] h-[87px] w-[174px] rounded-full bg-[#2565C8] opacity-80 blur-[124px]" />
            <div className="absolute -bottom-[312px] -right-[318px] hidden h-[624px] w-[636px] rounded-full bg-[#2565C8] opacity-40 blur-[476px] lg:block" />
            <div
              className="absolute right-[268px] top-[69px] hidden h-[86px] w-[336px] rotate-180 bg-no-repeat lg:block"
              style={{
                backgroundImage: `url(${blueLines})`,
              }}
            /> */}
            <Header onHoverChange={setIsHovered} />

            <Hero />
          </div>
          <section className="flex w-full flex-col items-center gap-12 border-y-[1px] border-[#1018280F] py-10">
            <span className="px-4 text-base text-gray-600">
              Trusted by leading companies and partners from around the world
            </span>
            <CompanySlider />
          </section>
          <ToolsTabs />
          {/* <Reviews /> */}
          <Advantages />
          <FinalSection />
        </main>
        <Footer />
      </div>
    </>
  );
};
